import PublicNavbar from "./PublicNavbar";
import PublicFooter from "./PublicFooter";
import PublicChatbox from "./PublicChatbox";
import AnalyticsTracker from "./AnalyticsTracker";
import SiteOrganizationSchema from "./SiteOrganizationSchema";

export default function PublicLayout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <SiteOrganizationSchema />
      <AnalyticsTracker />
      <PublicNavbar />
      <main className="flex-1">{children}</main>
      <PublicFooter />
      <PublicChatbox />
    </div>
  );
}
